module.exports = __webpack_public_path__ + "static/img/khdpc-nVVnI4Mp.672fd0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/khdpc-nVVnI4Mp.png
// module id = w7go
// module chunks = 16